<a *ngIf="!isAppNative" class="btn btn-primary rounded-pill d-flex p-2 px-{{textDisplayBreakpoint}}-3" [href]="getGuideRedirect()" target="_blank">
  <app-icon name="light-bulb"></app-icon>
  <span class="d-none d-{{textDisplayBreakpoint}}-block ms-2 my-auto">{{'BUTTON.HOW_TO_ENTER_LESSONS' | translate }}</span>
</a>
